export enum ITypeEnum {
  OFF_DAYS = "Off days",
  EXCEPTION = "Exception",
}
